import React, { useContext, useRef } from 'react'
import { Button, makeStyles, Theme, useTheme } from '@material-ui/core'
import useMuseStyles from '../../themes/useMuseStyles'
import clsx from 'clsx'
import CommunityCollaboratePage from './CommunityCollaboratePage'
import CommunityMessagesPage from './CommunityMessagesPage'
import CommunityProfilePage from './CommunityProfilePage'
import { CommunityPageTabTypes, UserContext, UserContextType } from '../../UserContext'
import { useCommunityFeature } from '../../services/useCommunityFeature'

export const useLocalStyles = makeStyles((theme: Theme) => ({
    roundedMuseTabGroupButton: {
        borderRadius: 20,
        border: '1px solid #F9CC04',
        padding: 0,
        background: '#202122 !important',
    },

    roundedMuseTabGroupActiveButton: {
        background: '#F9CC04 !important',
        border: '1px solid #F9CC04',

        '&:hover': {
            background: '#F9CC04 !important',
            border: '1px solid #F9CC04',
        },
    },

    roundedMuseTabGroupButtonLabel: {
        color: '#F9CC04',
        padding: '0px 15px',
        fontSize: '14px',

        '&::placeholder': {
            color: 'transparent',
        },
    },

    roundedMuseTabGroupActiveButtonLabel: {
        color: '#202122',
        '&:hover': {
            color: '#202122',
        },
    },
}))

function CommunityContainer({}: {}) {
    const classes = useLocalStyles(useTheme())
    const gclasses = useMuseStyles(useTheme())

    const { state, dispatch } = useContext(UserContext) as UserContextType

    const currentTab = state.community.communityPageCurrentTab
    const setCurrentTab = (tab: CommunityPageTabTypes) => {
        dispatch({
            type: 'update_community_state',
            value: { communityPageCurrentTab: tab },
        })
    }

    const containerStyles: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        border: 'solid 1px rgb(63, 63, 63)',
        height: 'calc(100% - 16px - 25px)',
        margin: '16px 25px',
        marginBottom: '25px',
        borderRadius: 7,
        overflow: 'overlay',
    }

    const communityFeature = useCommunityFeature()

    const communityContainerRef = useRef<HTMLDivElement | null>(null)

    // useEffect(() => {
    //     setTimeout(() => {
    //         if (communityContainerRef.current) {
    //             communityContainerRef.current.scrollTo(0, 0)
    //         }
    //     }, 5000)
    // }, [])

    return (
        <div id="community-container" style={containerStyles} ref={communityContainerRef}>
            <div
                style={{
                    display: 'flex',
                    flexGrow: 0,
                    width: 'fit-content',
                    border: 'solid 1px #F9CC04',
                    borderRadius: '20px',
                    margin: 'auto',
                }}
            >
                <Button
                    variant="outlined"
                    color="primary"
                    className={clsx(
                        classes.roundedMuseTabGroupButton,
                        currentTab === 'collaborate' && classes.roundedMuseTabGroupActiveButton
                    )}
                    classes={{
                        label: clsx(
                            classes.roundedMuseTabGroupButtonLabel,
                            currentTab === 'collaborate' && classes.roundedMuseTabGroupActiveButtonLabel
                        ),
                    }}
                    style={{ border: 'none', textTransform: 'none', padding: '0 18px', margin: '0', marginLeft: 0 }}
                    onClick={() => {
                        setCurrentTab('collaborate')
                    }}
                >
                    Collaborate
                </Button>

                <Button
                    variant="outlined"
                    color="primary"
                    className={clsx(
                        classes.roundedMuseTabGroupButton,
                        currentTab === 'messages' && classes.roundedMuseTabGroupActiveButton
                    )}
                    classes={{
                        label: clsx(
                            classes.roundedMuseTabGroupButtonLabel,
                            currentTab === 'messages' && classes.roundedMuseTabGroupActiveButtonLabel
                        ),
                    }}
                    style={{ border: 'none', textTransform: 'none', padding: '0 18px', margin: '0' }}
                    onClick={() => {
                        setCurrentTab('messages')
                    }}
                >
                    {communityFeature.unreadMessagesCount === 0
                        ? 'Messages'
                        : `Messages (${communityFeature.unreadMessagesCount})`}
                </Button>

                <Button
                    variant="outlined"
                    color="primary"
                    className={clsx(
                        classes.roundedMuseTabGroupButton,
                        currentTab === 'profile' && classes.roundedMuseTabGroupActiveButton
                    )}
                    classes={{
                        label: clsx(
                            classes.roundedMuseTabGroupButtonLabel,
                            currentTab === 'profile' && classes.roundedMuseTabGroupActiveButtonLabel
                        ),
                    }}
                    style={{ border: 'none', textTransform: 'none', padding: '0 18px', margin: '0' }}
                    onClick={() => {
                        setCurrentTab('profile')
                    }}
                >
                    Profile
                </Button>
            </div>

            <div id="community-tab-contents" style={{ marginTop: '16px', flexGrow: 2, position: 'relative' }}>
                {currentTab === 'collaborate' && <CommunityCollaboratePage containerRef={communityContainerRef} />}
                {currentTab === 'messages' && <CommunityMessagesPage />}
                {currentTab === 'profile' && <CommunityProfilePage />}
            </div>
        </div>
    )
}

export default CommunityContainer
